export default {
      id: "oc-res-app-llm-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-app-llm",
      toString: function () {
        return this.url;
      }
    }